import { EDITOR_MODES, VIEW_MODES } from 'crazyEditor/core/constants/editorConstants';


export function getStaticAssets(state) {
  return state.editor.staticAssets;
}

export function getFontList(state) {
  return state.editor.fontList;
}

export function isPreviewMode(state) {
  return state.routing.location.query.mode === EDITOR_MODES.PREVIEW;
}

export function isEditorMode(state) {
  return state.routing.location.query.mode !== EDITOR_MODES.PREVIEW;
}

export function isMobileView(state) {
  return state.routing.location.query.view === VIEW_MODES.MOBILE;
}

export function isDesktopView(state) {
  return state.routing.location.query.view !== VIEW_MODES.MOBILE;
}
